import type { MainPageSeoDto } from '@shared/api/mainPageSeo.dto'
import { createSeoHead } from '@shared/nuxt/createSeoHead'
import { useNuxtApi } from '@shared/nuxt/useNuxtApi'

const FALLBACK_TITLE =
  'Ресторан Farfor — доставка суши, роллов и пиццы более чем в 100 городах России'

/** Загружает и подготавливает SEO-данные главной страницы. */
export const useMainPageSeo = async () => {
  const route = useRoute()
  const { $host } = useNuxtApp()
  const { data: pageSeo } =
    await useNuxtApi<MainPageSeoDto>('/api/main-page-seo')
  const title = pageSeo.value?.title ?? FALLBACK_TITLE

  return {
    title,
    seo: createSeoHead(
      $host,
      {
        title,
        keywords: pageSeo.value?.keywords ?? '',
        description: pageSeo.value?.description ?? '',
      },
      route.fullPath,
      route.path,
    ),
  }
}
